import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/stores";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/sign-in",
      name: "sign-in",
      component: () => import("@/pages/login/Login.vue"),
      meta: { public: true, layout: "div" },
    },
    {
      path: "/",
      component: () => import("@/pages/home/Home.vue"),
      name: "home-page",
      meta: {
        title: "Admin Homepage",
      },
    },
    {
      path: "/merchant-list",
      component: () => import("@/pages/merchant-list/MerchantList.vue"),
      name: "merchant-list",
      meta: {
        title: "Merchant List",
      },
    },
    {
      path: "/client/:clientId",
      component: () => import("@/pages/client-info/index.vue"),
      name: "client-info-page",
      meta: {
        title: "Client Info",
      },
      children: [
        {
          path: "",
          component: () => import("@/pages/client-info/ClientInfo.vue"),
        },
        {
          path: "edit-company",
          name: "edit-company-page",
          component: () => import("@/pages/client-info/EditCompany.vue"),
        },
        {
          path: "edit-business-owner",
          name: "edit-business-owner-page",
          component: () => import("@/pages/client-info/EditBusinessOwner.vue"),
        },
        {
          path: "edit-pic",
          name: "edit-pic-page",
          component: () => import("@/pages/client-info/EditPIC.vue"),
        },
        {
          path: "edit-documents",
          name: "edit-documents-page",
          component: () => import("@/pages/client-info/EditDocuments.vue"),
        },
        {
          path: "integration",
          name: "client-integration-page",
          component: () =>
            import("@/pages/client-info/IntegrationDetails/index.vue"),
        },
        {
          path: "integration/:integrationId",
          name: "client-integration-info-page",
          component: () =>
            import("@/pages/client-info/IntegrationDetails/index.vue"),
        },
        {
          path: "resubmit-docs",
          name: "request-resubmit-docs-page",
          component: () => import("@/pages/client-info/ResubmitDocs.vue"),
        },
      ],
    },
    { path: "*", redirect: "/" },
  ],
});

router.beforeEach((to, from, next) => {
  const isDev = process.env.NODE_ENV === "development";
  const isValidURL = to.name !== "not-found"; // or error 404
  const isPublic = to.matched.some((route) => route.meta.public);
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  // Set page title
  document.title = to.meta?.title || "Brankas";

  // Check auth
  if (isValidURL && !isPublic && !isAuthenticated && !isDev) {
    next({
      path: "/sign-in",
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
});
